import React, { useState, useCallback, useRef } from "react";
import Styles from "./NewEditorStyles.module.css";
import { AutoComplete, Empty, Input, Spin } from "antd";
import { ReactComponent as SearchButtonIcon } from "./../../Icons/searchButton.svg";
import { ReactComponent as SearchFilterIcon } from "./../../Icons/searchFilter.svg";
import { ReactComponent as UploadQIcon } from "./../../Icons/uploadQ.svg";
import { ReactComponent as CrossIcon } from "./../../Icons/cross.svg";
import { fetchAutosuggestionsData, fetchSearchResultForEditor } from "../../API/api";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import { useLocation, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import { currentGroupName } from "../../API/url";
import ExpertQA from '../../NewComponent/answerBox/ExpertQA/index';
import NewQuestionBox from "./NewQuestionBox";
import KnowledgeEntrySearch from "./KnowledgeEntrySearchResult/KnowledgeEntrySearch";
import QuestionBox from './ExpertQA/QuestionBox'

import KeyTagQA from "../../NewComponent/answerBox/KeyTagQA/index";
import NewNameInfo from "./NewNameInfo";
import Tags from "./ExpertQA/Tags";
// import NameInfo from "./ExpertQA/NameInfo";
import Answer from "./ExpertQA/Answer";
import NewAnswer from "./NewAnswer";
import NewExpertAnswer from "./ExpertQA/NewExpertAnswer";

const containerStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  background: "#FFFFFF",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "24px 36px 24px 36px",
  minHeight: "100px",
  marginBottom: '24px'
};
const textStyles = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};
const textStyles1 = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};
export default function ExpertSearchBar({ onChangeFunc, createQa }) {
  const [suggestion, setSuggestion] = useState([]);
  const [isStapled, setIsStapled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tx, setTx] = useState("");
      // const navigate = useNavigate();
  const [activeOption, setActiveOption] = useState(null); 
  const currentRoute = useLocation();
  const [inputVal, setInputval] = useState('');
  const [searchedData, setSearchData] = useState([]);
  const editorState = useSelector(state => state.editor);
  const [response, setResponse] = useState(null)
  const { updateAnswerTextForEditor, } = bindActionCreators(Actions, dispatch);
  // const currentRoute = useLocation();
  // const navigate = useNavigate();
  // const [inputWidth, setInputWidth] = useState(0);
  // const [isFocus, setIsFocus] = useState(false);
  // const dispatch = useDispatch();
  const isSelectedRef = useRef(false);
  // const [text, setText] = useState(inputVal);
  const [isSelected, setIsSelected] = useState(false); // Track if a suggestion was selected

  const [selected,setSelected]=useState(false)
  const [searchBool, setSearchBool] = useState(false)
  const domainState = useSelector((state) => state.domain);
  const [isLoading, setIsLoading] = useState(false);
  const {
    getAutoSuggestionData,
  } = bindActionCreators(Actions, dispatch);


  const onChangeText = (e) => {
    debouncedFetchOptions(e);
    setInputval(e)
    // setText(e);
    // searchInputValue(e);
    setSuggestion(new Array());
  
  }

  const filterOptions = (arr) => {
    let newArr = new Array();
    arr.map((ar, ind) => {
      newArr.push({ value: ar.question, key: ind + 1 });
    });
    return newArr;
  }


  const onSearchText = (value) => {
    if (value.trim().length > 4) {
      fetchAutosuggestionsData(value, getAutoSuggestionData)
        .then((res) => {
          if (res === undefined) return;
          setSuggestion([...filterOptions(res)]);
        }).catch((err) => { });

    }
  }

  const debouncedFetchOptions = useCallback(
    debounce((value) => onSearchText(value), 100),
    []
  );

  const onPress = (val) => {
    // console.log("out press side")
    setSuggestion(new Array())
    // inputVal, false
    // console.log(" press enter outside the api")
    if (val.length >= 4) {
      setIsLoading(true);
      // setSearchBool(true)
      const searchPayload = {
        question: val,
        domains: domainState.selectedDomain,
        origQuestionUuid: "",
        spellCheckFlag: false,
        type: "Vizerto",
        searchmethod: "bert"
      };
      // console.log("press enter inside the submit")

      fetchSearchResultForEditor(searchPayload).then(res => {
        if (res === undefined) return;
        let userUuid = [];
        if (res.data.success) {
          if (res.data.data[0].searchData.length === 0) {
            setSearchBool(true)
          }
          let newArr = res.data.data[0].searchData.filter(qa => {
            if (qa.docType === 'expertqa') {
              return qa;
            }
          })

          setSearchData(newArr);
          // const inputBlurs = document.querySelector("#myInput")
          // inputBlurs.blur();
          // setSearchBool(false)
          setIsLoading(false);
        }
      })
      setIsLoading(false)
    }
  }

  const handleSubmit = useCallback(
    (val, type) => {
      if (val.trim().length < 4 || isSelectedRef.current) return; // Block duplicate calls

      setIsLoading(true);
      setSuggestion([]);

      const searchPayload = {
        question: val,
        domains: domainState.selectedDomain,
        origQuestionUuid: "",
        spellCheckFlag: false,
        type: "Vizerto",
        searchmethod: "bert",
      };

      // console.log("searchPayload 2");

      fetchSearchResultForEditor(searchPayload).then((res) => {
        if (!res) return;
        // console.log("res", res.data.data[0].searchData.length);

        if (res.data.success) {
          if (res.data.data[0].searchData.length === 0) {
            setSearchBool(true);
          }

          let newArr = res.data.data[0].searchData.filter((qa) => qa.docType === "expertqa");

          setSearchData(newArr);
          setIsLoading(false);

          // Reset selection flag after API call completes
          setTimeout(() => {
            isSelectedRef.current = false;
          }, 500);
        }
      });
    },
    [domainState.selectedDomain]
  );



  const onSubmit = (val, type) => {
    if (val.trim().length < 4) return; // Block if already submitting

  // setIsSubmitting(true); // Prevent further calls
      setIsLoading(true);
  

    // setSearchBool(true)
    const searchPayload = {
      question: val,
      domains: domainState.selectedDomain,
      origQuestionUuid: "",
      spellCheckFlag: false,
      type: "Vizerto",
      searchmethod: "bert"
    };

   

    fetchSearchResultForEditor(searchPayload).then(res => {
      if (res === undefined) return;
      let userUuid = [];
      // console.log("res", res.data.data[0].searchData.length)

      if (res.data.success) {
        if (res.data.data[0].searchData.length === 0) {
          setSearchBool(true)
        }
        else setSearchBool(false)
        let newArr = res.data.data[0].searchData.filter(qa => {
          if (qa.docType === 'expertqa') {
            return qa;
          }
        })

        setSearchData(newArr);
        // const inputBlurs = document.querySelector("#myInput")
        // inputBlurs.blur();
        // setSearchBool(false)
        setIsLoading(false);
        setSelected(false)
      }
    })
    // setIsLoading(false)

  }


  const filterOption = (inputValue, option) => {
    // console.log(inputValue, option);
    return option.value

  }


  // console.log("createQa",createQa)

  const sendToSearchPage = (e, val) => {

    // console.log("event", e)
    // e.preventDefault();
    setSuggestion([]);
    const searchPayload = {
      question: e,
      domains: domainState.selectedDomain,
      origQuestionUuid: "",
      spellCheckFlag: false,
      type: "Vizerto",
      searchmethod: "bert"
    };
    fetchSearchResultForEditor(searchPayload).then(res => {
      // console.log('response', res)
      if (res === undefined) return;

      if (res.data.success) {
        setResponse(res)
        let newArr = res.data.data[0].searchData.filter(qa => {
          if (qa.docType === 'expertqa') {
            return qa;
          }
        })
        setSearchData(newArr);
        const inputBlurs = document.querySelector("#myInput")
        // inputBlurs.blur();
        setIsLoading(false);
      }

    })
  };

  const noDataAvailable = () => {
    return (
      <div className="trendingfilterbar" style={{ textAlign: "center" }}>
        <Empty />
      </div>
    );
  };

  const onClickStapleAnswer1 = (str) => {
    setIsStapled(true);
    console.log("copy str", str)
    setTx(str.answerCopy)
    if (currentRoute.pathname.includes('editor')) {
      let newStr = editorState.answerText.concat(str.answerText);
      updateAnswerTextForEditor(newStr)
    } else {
      onChangeFunc(str);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // setTx(str)
    // if(currentRoute.pathname.includes('editor')){
    //   let newStr = editorState.answerText.concat(str);
    //   updateAnswerTextForEditor(newStr)
    // }else{
    //   onChangeFunc(str);
    // }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const onClickStapleAnswers = (str) => {
    // setIsStapled(true);

    // setTx(str.answerCopy)
    // console.log("string")
    if (currentRoute.pathname.includes('editor')) {
      let newStr = editorState.answerText.concat(str.answerCopy);
      updateAnswerTextForEditor(newStr)
    } else {
      onChangeFunc(str);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // console.log("isLoading",isLoading)
  const onClickStapleAnswer = (str) => {
    setIsStapled(true);
    // console.log("copy str", str);

    if (typeof str === "string") {
      setTx(str);
    } else if (typeof str === "object" && str !== null && "answerCopy" in str) {
      setTx(str.answerCopy);
    } else {
      console.error("Invalid input: str must be a string or an object with 'answerCopy' property");
      return;
    }

    if (currentRoute.pathname.includes('editor')) {
      let newStr;

      if (typeof str === "string") {
        newStr = editorState.answerText.concat(str);
      } else {
        newStr = editorState.answerText.concat(str.answerText);
      }

      updateAnswerTextForEditor(newStr);
    } else {
      onChangeFunc(str);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // console.log("searchedData",searchedData )
  return (

    <div style={{ padding: "15px", paddingBottom: '0px' }}>
      {
        createQa && <div style={{ paddingBottom: "15px", paddingTop: "7px" }}>
          <div style={textStyles}>
            <b>Staple the answer:</b>
          </div>
          <div style={{ fontSize: "16px" }}>
            Experts can respond by reusing answers from other questions
          </div>
        </div>
      }
           <AutoComplete
      popupMatchSelectWidth={"100%"}
      style={{ width: "100%", height: "60px" }}
      popupClassName={Styles.searchSuggestionCss}
      options={suggestion}
      filterOption={filterOption}
      onSelect={(value) => {
        isSelectedRef.current = true; // Mark selection
        setInputval(value);
        onSubmit(value); // Call submit immediately on select

        // Reset selection flag after a short delay
        setTimeout(() => {
          isSelectedRef.current = false;
        }, 500);
      }}
      onChange={(value) => {
        if (!isSelectedRef.current) {
          debouncedFetchOptions(value)
          setInputval(value);
          onChangeText(value);
        }
      }}
      onDropdownVisibleChange={(open) => {
        if (!open) {
          setActiveOption(null); // Reset active suggestion when dropdown closes
        }
      }}
      onFocus={() => {
        setActiveOption(null); // Reset when input is focused
      }}
      onBlur={() => {
        setSuggestion([]); // Clear suggestions on blur
      }}
      onKeyDown={(e) => {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          setActiveOption(e.key === "ArrowDown" ? (activeOption ?? -1) + 1 : (activeOption ?? 0) - 1);
        }
      }}
    >

      <div className={Styles.searchBar}>
        <Input
          autoComplete="off"
          id="inputID"
          size="large"
          value={inputVal}
          type="text"
          placeholder="Ask your question"
          style={{ border: "none", color: "#5C667B", fontSize: "18px", fontWeight: "400" }}
         onPressEnter={() => {
            // console.log("Enter Pressed, isSelectedRef:", isSelectedRef.current, "Active Option:", activeOption);
            if (!isSelectedRef.current && !(suggestion.length > 0 && activeOption !== null)) {
              onSubmit(inputVal, false); // Only trigger if not selecting a suggestion
            }
          }}

        />
        {inputVal.trim().length !== 0 && (
          <CrossIcon onClick={() => onChangeText("")} style={{ marginInline: "5px" }} />
        )}
        <SearchButtonIcon
          style={{
            opacity: `${inputVal.trim().length < 4 ? ".4" : "1"}`,
            marginTop: "2px",
            cursor: `${inputVal.trim().length < 4 ? "not-allowed" : "pointer"}`,
          }}
          onClick={() => onSubmit(inputVal, false)}
        />
      </div>
    </AutoComplete>




      <div className="mt-5">
        <Spin size="large" spinning={isLoading} style={{ display: 'flex', paddingBottom: "10px" }} >
          {
            searchedData.length > 0 && searchedData.map((qas, ind) => {
              // console.log("qas",qas)
              return (
                <>
                  <div style={containerStyle}>
                    <QuestionBox question={qas} fav={false} />
                    <Tags data={qas} />
                    {
                      qas?.answers?.map((val, index) => {
                        // console.log('check time', val)
                        return <>
                          <NewNameInfo data={val} question={qas} />
                          <NewExpertAnswer data={val} question={qas} onClickStapleAnswer={onClickStapleAnswers} stapple={true} />
                          {qas.answers.length - 1 !== index && <p className={Styles.onSelectedtab} style={{ marginBottom: '10px', marginTop: '15px' }}></p>}

                        </>
                      })
                    }


                  </div>
                </>
              )
            })

          }
          {
            searchBool && searchedData.length === 0 && noDataAvailable()
          }
        </Spin>
      </div>
    </div>
  )


}
